import React from 'react'
import _ from 'lodash'
import * as immutable from 'immutable'

import categoryUtil from '../../util/category.util'

const CDN_URL = 'https://4wi83c2lj5.execute-api.us-west-2.amazonaws.com/prod/redirector?key='

export class ImageThumb extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            imgHeight: 0
        }

        this._icon = categoryUtil.getIcon(this.props.item)
        this._hasThumb = false

        _.bindAll(this,
            'getImage',
            'getImagePath',
            'setThumbHeight'
        )
    }

    componentDidMount() {
        if (this.props.type === 'related-content') {
            if (this.refs) {
                if (this.refs.thumbnail) {
                    window.addEventListener('resize', _.debounce(() => {
                        this.setThumbHeight()
                    }, 250))
                    this.setThumbHeight()
                }
            }
        }
    }

    componentDidUpdate() {
        if (this.refs && this.refs.thumbnail && this.refs.thumbnail.offsetParent !== null) {
            this.setThumbHeight()
        }
    }

    setThumbHeight() {
        if (this.refs.thumbnail) {
            if (this.refs.thumbnail.offsetWidth) {
                let cW = this.refs.thumbnail.offsetWidth
                let nH = cW / 2.275
                if (this.state.imgHeight !== nH) {
                    this.setState({imgHeight: nH})
                }
            }
        }
    }

    getPlaceholderThumb() {
        let name = this.props.item.get('title') ? this.props.item.get('title') : this.props.item.get('name')
        if (!name) {
            name = 'a'
        }
        let ext = Math.ceil((name.toLowerCase().charCodeAt(0) - 97) / 4.33333)

        let type = this.props.model ? this.props.model : 'destination' // use model or default to dest
        return '/assets/img/layout/thumb_bgs/' + type + '-bg' + '-0' + ext + '.jpg'
    }

    getGooglePlacesThumb() {
        let photos = this.props.item.getIn(['accommodation_place_details', 'details', 'photos']) || this.props.item.getIn(['accommodation_place_details', 'photos']) || immutable.List()
        photos = photos.toJS()
        // since this is a thumb, try to get a landscape version
        let landscapes = _.filter(photos, function (img) {
            if (img) {
                return img.width > img.height
            } else {
                return false
            }
        })
        if (landscapes.length > 0) {
            let imgPath = 'https://maps.googleapis.com/maps/api/place/photo?maxwidth=360&photoreference='
                + landscapes[0].photo_reference
                + '&key=AIzaSyCvwt0NnxLgeRxHrpdd1eRRVmvXcMVylJI'
            this._hasThumb = true
            return imgPath
        } else {
            return this.getPlaceholderThumb()
        }
    }

    getImagePath() {
        if (this.props.item.get('icon_image')) {
            let backgroundImage = this.props.item.get('icon_image')
            return '/' + backgroundImage.get('filename')
        } else if (this.props.item.get('images')) {
            let itemThumb = this.props.item.get('images')
            if (itemThumb.getIn([0, 'filename'])) {
                this._hasThumb = true
                return '/' + itemThumb.getIn([0, 'filename'])
            } else {
                // check to see if there is a google reference
                let photos = this.props.item.getIn(['accommodation_place_details', 'details', 'photos']) || this.props.item.getIn(['accommodation_place_details', 'photos']) || immutable.List()
                if (photos.size) {
                    return this.getGooglePlacesThumb()
                } else {
                    return this.getPlaceholderThumb()
                }
            }
        } else if (this.props.item.getIn(['accommodation_place_details', 'details', 'photos'])) {
            // in the event we don't have images at all but have google details
            return this.getGooglePlacesThumb()
        } else {
            return this.getPlaceholderThumb()
        }
    }

    getImage() {
        if (this.props.item.get('images') && typeof this.props.item.get('images') !== 'string') {
            let imgPath = this.getImagePath()
            if (imgPath.substring(0, 4) !== 'http') imgPath = CDN_URL + '100x100' + imgPath
            if (this._hasThumb && !this.props.useIcon) {
                let urlImage = 'url(' + imgPath + ')'
                return <div className="thumbnail-image" style={{'backgroundImage': urlImage}}/>
            } else {
                return categoryUtil.getIcon(this.props.item)
            }
        } else {
            return categoryUtil.getIcon(this.props.item)
        }
    }

    render() {
        if (this.props.type === 'related-content' || this.props.type === 'promoted-region') {
            let imgPath = this.getImagePath()
            if (imgPath.substring(0, 4) !== 'http') imgPath = CDN_URL + '300x200' + imgPath
            let bgImage = 'url(' + imgPath + ')'
            if (this._hasThumb) {
                return <div ref="thumbnail" className="related-content-thumb" style={{'backgroundImage': bgImage, 'height': this.state.imgHeight}} onClick={() => {this.props.showDetails(this.props.item)}}/>
            } else {
                return (
                    <div ref="thumbnail" className="related-content-thumb" style={{'backgroundImage': bgImage, 'height': this.state.imgHeight}} onClick={() => this.props.showDetails(this.props.item)}>
                        {this._icon}
                    </div>
                )
            }
        } else if (this.props.type === 'overview-list') {
            let imgPath = this.getImagePath()
            if (imgPath.substring(0, 4) !== 'http') imgPath = CDN_URL + '200x200' + imgPath
            let bgImage = 'url(' + imgPath + ')'
            if (this._hasThumb) {
                return <div onClick={() => this.props.showDetails(this.props.item)} className="list-item-icon" style={{'backgroundImage': bgImage}}/>
            } else {
                return <div onClick={() => this.props.showDetails(this.props.item)} className="list-item-icon" style={{'backgroundImage': bgImage}}>{this._icon}</div>
            }
        } else {
            return <div onClick={() => this.props.showDetails(this.props.item)} className="list-item-icon">{this.getImage()}</div>
        }
    }
}
